import { Navigate } from "react-router-dom";
import { useAuthContext } from "@authentication/context";
import adminEntries from "constants/adminEntries.json";
import { UnAuthorized } from "pages/errors";
import { jsx as _jsx } from "react/jsx-runtime";
export default function RestrictedPath(_ref) {
  var _adminEntries$find;
  var resource = _ref.resource,
    children = _ref.children;
  var _useAuthContext = useAuthContext(),
    getUserAccess = _useAuthContext.getUserAccess;
  var userAccess = getUserAccess();
  if (userAccess[resource]) return children;

  //check if specific resource has access true
  var subEntryWithAccess = function subEntryWithAccess(entry) {
    var _entry$entries;
    return (_entry$entries = entry.entries) === null || _entry$entries === void 0 ? void 0 : _entry$entries.find(function (subEntry) {
      return userAccess[subEntry.resource];
    });
  };

  //find a subEntry with access true
  var subEntry = (_adminEntries$find = adminEntries.find(subEntryWithAccess)) === null || _adminEntries$find === void 0 ? void 0 : _adminEntries$find.entries.find(function (subEntry) {
    return userAccess[subEntry.resource];
  });

  //if we have access to subEntry, redirect
  if (subEntry) return /*#__PURE__*/_jsx(Navigate, {
    to: subEntry.to,
    replace: true
  });

  //find a topEntry with access true
  var topEntry = adminEntries.find(function (entry) {
    return userAccess[entry.resource];
  });

  //if we have access to topEntry, redirect
  if (topEntry) return /*#__PURE__*/_jsx(Navigate, {
    to: topEntry.to,
    replace: true
  });

  //If we have no access, redirect to unauthorized
  return /*#__PURE__*/_jsx(UnAuthorized, {});
}